import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/translations";

const LanguageContext = createContext({
  lang: "hu",
  t: translations.hu,
  toggle: () => {},
  setLang: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "hu";
    return window.localStorage.getItem("ns_lang") || "hu";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("ns_lang", lang);
      document.documentElement.setAttribute("lang", lang);
    } catch {}
  }, [lang]);

  const setLang = useCallback((next) => {
    if (next === "hu" || next === "en") setLangState(next);
  }, []);

  const toggle = useCallback(() => {
    setLangState((prev) => (prev === "hu" ? "en" : "hu"));
  }, []);

  const value = {
    lang,
    t: translations[lang],
    toggle,
    setLang,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
